export default {
  wrapperBackgroundColor: Styles.color.cardBackground,
  nameTextCase: 'initial',
};
